import { connect } from 'react-redux';
import { IAppState } from '../../../../common/state';
import { HeaderDeveloper } from './index';

export const HeaderDeveloperContainer = connect((state: IAppState) => ({
  breadcrumbs: state.breadcrumbs,
  developerInfo: state.results.developerInfo,
}))(HeaderDeveloper);
